/*
 * 公共函数
 * @Author: baixiaoming
 * @Date: 2018-12-18 15:53:59
 * @Last Modified by: xiaoming.bai
 * @Last Modified time: 2020-06-29 16:32:10
 */

var $ = require('jquery')

const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    var r = window.location.search.substr(1).match(reg)
    return r != null ? unescape(r[2]) : null
}

const getQuerySearchString = (key) => {
    var url = location.search //获取url中"?"符后的字串
    var theRequest = {}

    if (url.indexOf("?") !== -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
    }
    return key ? theRequest[key] : theRequest
}

const getQueryHashString = (key) => {
    var hash = location.hash;
    var hashObj = {};

    if (hash.indexOf('#') > -1) {
        var str = hash.replace('#', '');
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            hashObj[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }

    if (key) {
        return hashObj[key];
    } else {
        return hashObj;
    }
}

// 返回 下一级的 zoom
const getZoom = (level) => {
    var districtType = 3,
        markerType = 4;

    if (level == districtType) {
        return 10;
    }
    if (level == markerType) {
        return 12;
    }

    return 10;
}

//根据 zoom 返回当前的 Type
const getLevelType = (zoom) => {
    var districtType = 3,
        markerType = 4;

    if (zoom > 11) {
        return markerType;
    } else {
        return districtType
    }
}

// 返回登录 encode url
const passpportLogin = (url) => {
    window.location.href = '/passport/login?refer=' + encodeURIComponent(url);
}

/**
 * 去除字符串中的空格
 * @param {*} str 操作字符串
 * @param {*} type 1: 前后空格(默认) 2: 所有空格  3: 前空格 4: 后空格
 */
const trim = (str, type = 1) => {
    let typeMapping = {
        1: /(^\s*)|(\s*$)/g,
        2: /\s+/g,
        3: /(^\s*)/g,
        4: /(\s*$)/g,
    }
    return str.replace(typeMapping[type], '')
}

module.exports = {
    getQueryString,
    getQuerySearchString,
    getQueryHashString,
    getZoom,
    getLevelType,
    passpportLogin,
    trim
}



//////////////////
// WEBPACK FOOTER
// ./src/global/js/common.js
// module id = 12
// module chunks = 0 1 2 3